import React from 'react';
import {StatusBar} from 'react-native';
import {useTheme} from '../helpers/ThemeContext';

/**
 * StatusBar whose bar style follows the active colour scheme. The bar itself
 * stays hidden (the app draws edge-to-edge), but when it is briefly revealed —
 * or on platforms that keep a translucent bar — the icons stay legible against
 * the themed background: dark icons on light, light icons on dark.
 *
 * @returns {React.ReactElement} A theme-driven StatusBar.
 */
const ThemedStatusBar = () => {
  const {isDark} = useTheme();

  return (
    <StatusBar
      hidden={true}
      backgroundColor="transparent"
      barStyle={isDark ? 'light-content' : 'dark-content'}
    />
  );
};

export default ThemedStatusBar;
